export default __webpack_public_path__ + "lock.f6e0afd67624377d.svg";